const { v4: uuidv4 } = require('uuid');

export default [
  {
    key: uuidv4(),
    name: null,
    fields: [
      {
        name: 'firstName',
        label: 'First Name',
        type: 'text',
        validation: 'required',
        dense: true,
        hideDetails: true
      },
      {
        name: 'lastName',
        label: 'Last Name',
        type: 'text',
        validation: 'required',
        dense: true,
        hideDetails: true
      },
      {
        name: 'initials',
        label: 'Initials',
        type: 'text',
        validation: 'required',
        dense: true,
        hideDetails: true
      },
      {
        name: 'email',
        label: 'Email',
        type: 'text',
        validation: 'required|email',
        dense: true,
        hideDetails: true
      },
      {
        name: 'password',
        label: 'Password',
        type: 'password',
        validation: 'required|min:8',
        dense: true,
        hideDetails: true,
        eye: true
      },
      {
        name: 'role',
        label: 'Role',
        type: 'select',
        validation: 'required',
        items: ['admin', 'supervisor', 'user'],
        dense: true,
        hideDetails: true
      },
      {
        name: 'active',
        label: 'Active',
        type: 'checkbox',
        default: true,
        color: 'primary',
        hideDetails: true
      }
    ]
  }
];
